var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-item"},[(_vm.label)?_c('label',{attrs:{"for":`${_vm.name}-field`}},[_vm._v(_vm._s(_vm.label)+":")]):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('field-error',{attrs:{"prop":_vm.name}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }